import React from "react";
import { Reveal } from "@progress/kendo-react-animation"
import { ExpansionPanel, ExpansionPanelContent, ExpansionPanelActionEvent } from "@progress/kendo-react-layout"
import { QandA } from "./QandA"
import { ExpansionPanelWistiaPlayer } from '../../components/WistiaPlayer'

export const FAQPage = () => {
    const [expanded, setExpanded] = React.useState("");
    const onActionFunction = (id: string) => {
        return (event: ExpansionPanelActionEvent) => {
            setExpanded(event.expanded ? "" : id);
        }
    };

    return (<>
        {QandA.map((qa: any) => (
            <ExpansionPanel
                title={qa.q}
                expanded={expanded === qa.id}
                tabIndex={0}
                key={qa.id}
                onAction={onActionFunction(qa.id)}>
                <Reveal>
                    {expanded === qa.id && (
                        <ExpansionPanelContent>
                            <div className="content">
                                <span className="content-text">{qa.a}</span>
                            </div>
                        </ExpansionPanelContent>
                    )}
                </Reveal>
            </ExpansionPanel>))}

        <br></br>
        <br></br>

        <ExpansionPanelWistiaPlayer
            title={'Streck PVS General Use'}
            videoId={'4oltvxjlq4'}
            expanded={expanded}
            onAction={onActionFunction} />
        <ExpansionPanelWistiaPlayer
            title={'Onboarding'}
            videoId={'iovvdkx7yp'}
            expanded={expanded}
            onAction={onActionFunction}/>
        <ExpansionPanelWistiaPlayer
            title={'How To Create New Lab'}
            videoId={'1nd53o0x19'}
            expanded={expanded}
            onAction={onActionFunction}/>
        <ExpansionPanelWistiaPlayer
            title={'How To Add New Operator'}
            videoId={'0nwef8uv2p'}
            expanded={expanded}
            onAction={onActionFunction}/>
        <ExpansionPanelWistiaPlayer
            title={'How To Create New Pipet'}
            videoId={'ou8qft6qas'}
            expanded={expanded}
            onAction={onActionFunction}/>
        <ExpansionPanelWistiaPlayer
            title={'How To Submit New Kit'}
            videoId={'mh1mv4wdwp'}
            expanded={expanded}
            onAction={onActionFunction}/>
    </>);
};